import { MUser } from '@argalis-apps/models';
import { Injectable } from '@angular/core';
import { CommunicationConfigService } from '@argalis-apps/angular-global';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProfileInformationsService {
  constructor(private communicationConfigService: CommunicationConfigService, private http: HttpClient) {}

  updateProfileInformationsToServer(user: MUser.IUser) {
    return this.http.put<boolean>(`${this.communicationConfigService.getApiUri()}/client/profile-informations`, user);
  }

  getDocumentCGV(): Observable<string | HttpErrorResponse> {
    return this.http.get<string>(`${this.communicationConfigService.getApiUri()}/document/cgv`);
  }

  getClientBySiren(siren: string): Observable<MUser.IContact> {
    let params = new HttpParams();
    params = params.set('siren', siren);
    return this.http.get<MUser.IContact>(`${this.communicationConfigService.getApiUri()}/client/siren-info`, {
      params
    });
  }
}
